import { AppFundaContactRequestPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../../../constants';

export default (): AppFundaContactRequestPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.EVENT_CONTACT_APP_FUNDA_CONTACTREQUEST_POINTER,
  variable: null,
});
